import Guid from '@/app/utils/guid'
import { Bias } from './bias'
import NodeEntity from '@/common/models/node-entitiy'

export default class Topic extends NodeEntity {

    public groupId = Guid.empty()
    public excerpt = ''
    public rationale = ''
    public facts = ''
    public message = ''
    public bias = Bias.Neutral
    public isWinner = false
    public isActive = true
    public order = 0
}
